import { Pipe } from '@angular/core';
var TruncateWordsPipe = (function () {
    function TruncateWordsPipe() {
    }
    TruncateWordsPipe.prototype.transform = function (value, limit, trail) {
        if (limit === void 0) { limit = 40; }
        if (trail === void 0) { trail = '…'; }
        var result = value || '';
        if (value) {
            var words = value.split(/\s+/);
            if (words.length > Math.abs(limit)) {
                if (limit < 0) {
                    limit *= -1;
                    result = trail + words.slice(words.length - limit, words.length).join(' ');
                }
                else {
                    result = words.slice(0, limit).join(' ') + trail;
                }
            }
        }
        return result;
    };
    TruncateWordsPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'words'
                },] },
    ];
    /** @nocollapse */
    TruncateWordsPipe.ctorParameters = function () { return []; };
    return TruncateWordsPipe;
}());
export { TruncateWordsPipe };
//# sourceMappingURL=truncate-words.pipe.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/ng2-truncate/dist/truncate-words.pipe.js
// module id = ../../../../ng2-truncate/dist/truncate-words.pipe.js
// module chunks = 4